import './Testimonials.scss';
import Sliders from '../Sliders/Sliders';
const Testimonials = () => {
    return(
        <section className='arta-testimonials'>
            <div className='arta-testimonials__sliders'>
                <h2>Our Client Said</h2>
            </div>
            <Sliders />
        </section>
    )
}

export default Testimonials;
